import { HttpClient } from '@/shared/infra/http/HttpClient';
import {
  AccountOption,
  QueueAdminList,
  QueueAdminQuery,
} from '../../application/domain/entities/EverifyQueueAdmin';

/** The super-admin E-Verify queue. Integration-service owns the queue; core owns the account list. */
export class ApiEverifyQueueAdminRepository {
  constructor(
    private readonly integration: HttpClient,
    private readonly core: HttpClient
  ) {}

  async list(query: QueueAdminQuery): Promise<QueueAdminList> {
    const params = new URLSearchParams({
      page: String(query.page),
      pageSize: String(query.pageSize),
      includeMouBlocks: String(query.includeMouBlocks),
      includeResolved: String(query.includeResolved),
      includeArchived: String(query.includeArchived),
    });
    if (query.categories?.length) params.set('category', query.categories.join(','));
    if (query.accountId) params.set('accountId', query.accountId);
    if (query.search?.trim()) params.set('search', query.search.trim());
    const res = await this.integration.get<QueueAdminList>(
      `/e-verify/admin/queue?${params.toString()}`
    );
    return res.data;
  }

  async returnToQueue(everifyCaseQueueId: string): Promise<void> {
    await this.integration.post(`/e-verify/admin/queue/${everifyCaseQueueId}/return-to-queue`);
  }

  async requeueMou(everifyCaseQueueId: string): Promise<void> {
    await this.integration.post(`/e-verify/admin/queue/${everifyCaseQueueId}/requeue-mou`);
  }

  async accounts(): Promise<AccountOption[]> {
    const res =
      await this.core.get<Array<{ id: string; accountName: string }>>('/account/all-accounts');
    return (res.data ?? [])
      .map((account) => ({ id: account.id, name: account.accountName }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }
}
